var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMineral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 74.75C36.4167 78.9842 33.8423 80.5 30.6667 80.5C27.491 80.5 24.9167 78.9842 24.9167 74.75C24.9167 70.5158 30.6667 65.1667 30.6667 65.1667C30.6667 65.1667 36.4167 70.5158 36.4167 74.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0833 74.75C67.0833 78.9842 64.509 80.5 61.3333 80.5C58.1577 80.5 55.5833 78.9842 55.5833 74.75C55.5833 70.5158 61.3333 65.1667 61.3333 65.1667C61.3333 65.1667 67.0833 70.5158 67.0833 74.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 51.75C51.75 55.9842 49.1756 57.5 46 57.5C42.8244 57.5 40.25 55.9842 40.25 51.75C40.25 47.5158 46 42.1667 46 42.1667C46 42.1667 51.75 47.5158 51.75 51.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.501 31.5968C7.00996 27.1058 7.00996 19.8244 11.501 15.3333C15.992 10.8423 23.2734 10.8423 27.7644 15.3333L38.6068 26.1756L22.3433 42.4391L11.501 31.5968Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4992 31.5968C84.9902 27.1058 84.9902 19.8244 80.4992 15.3333C76.0081 10.8423 68.7267 10.8423 64.2357 15.3333L53.3934 26.1756L69.6569 42.4391L80.4992 31.5968Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineral);
export default __webpack_public_path__ + "static/media/mineral.9af1cc2705fe424a95f54ca4d79e40a7.svg";
export { ForwardRef as ReactComponent };